// export { logo } from './logo.png'
const fetchAllImages = () => {
    const images = require.context('./', false, /\.(png|jpe?g|svg)$/);
    const imgList = {};
    images.keys().map(image => {
        let keyName = image.replace('./', '')
        keyName = keyName.split('.')[0]
        imgList[keyName]= images(image)
        return null
    });
    return imgList
}
export const imageList = fetchAllImages();

// function importAll(r) {
//     return r.keys().map(r);
//   }
  
//   export const imagesArr = importAll(require.context('./', false, /\.(png|jpe?g|svg)$/));

